const React = require("react");
const {Drawer} = require("@material-ui/core");
const {Close: CloseIcon} = require("@material-ui/icons");
const AppIcon = require("../../../../../icons/Lunu");
const Navigation = require("../../Navigation");
const UserDisplay = require("../../UserDisplay");

module.exports = ({isMenuOpen, toggleMenu}) => (
  <Drawer open={isMenuOpen} onClose={toggleMenu}>
    <div className="h pl30 pr40 bg3e4044">
      <div className="h layoutRow fxdColumn">
        <div className="layoutRow aiC">
          <div className="pr20 mr10 crPointer" onClick={toggleMenu}>
            <CloseIcon className="cF" />
          </div>
          <AppIcon className="w128 h80 rlv cF" />
        </div>
        <div className="h1 bgDADCE1 w"/>
        <Navigation onClick={toggleMenu} />
        <div className="mtAuto dB@m2">
          <div className="h1 bgDADCE1 w"/>
          <UserDisplay isHiddenMenu />
        </div>
      </div>
    </div>
  </Drawer>
)